export function transformAdminUIProviderToModel(
  existingProvider?: string | null | undefined
): string {
  if (!existingProvider) {
    return 'CORP_ADMIN';
  }

  return existingProvider;
}
